import type { ReactNode } from "react";
import { Slide, toast, type ToastOptions } from "react-toastify";

/**
 * The app's toast configuration.
 *
 * It was four call sites out of thirty when this file was written, and the comment here said landing
 * the rest was its own change. This is that change: the twenty-six inlined near-copies are gone, so
 * moving `position` moves every toast in the app rather than a corner of it. The copies differed
 * only in `autoClose` and in `progress: undefined`, which react-toastify ignores — the two that
 * genuinely differed (`theme`, `bodyClassName`) pass their difference as an override.
 */
const BASE_OPTIONS: ToastOptions = {
	position: "top-left",
	hideProgressBar: true,
	closeOnClick: true,
	closeButton: false,
	pauseOnHover: false,
	draggable: false,
	pauseOnFocusLoss: false,
	transition: Slide,
	autoClose: 2500,
};

export const showAppToast = (message: ReactNode, options: ToastOptions = {}) =>
	toast(message, { ...BASE_OPTIONS, ...options });

/** The same shell for the failure variant, so a surface needing both does not reach past this file. */
export const showAppErrorToast = (message: ReactNode, options: ToastOptions = {}) =>
	toast.error(message, { ...BASE_OPTIONS, ...options });
